import React, { useState, useRef } from 'react';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// Importando servicos e componentes
import api from '~/services/api';
import history from '~/services/history';
import Card from '~/components/Card';
// Importando componentes
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';

import { Container } from './styles';

export default function IntegracaoNew() {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
        url: Yup.string().required('Preencha o campo url'),
        post: Yup.string().required('Preencha o campo post'),
        url_produtos: Yup.string(),
        url_corretores: Yup.string(),
        parametro: Yup.string(),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post('/integracao', {
        name: data.name,
        url: data.url,
        post: data.post,
        url_produtos: data.url_produtos,
        url_corretores: data.url_corretores,
        parametro: data.parametro,
      });

      toast.success('Integração cadastrada com sucesso');
      history.push('/integracao');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Integração já foi cadastrada.');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Cadastro de Integração</h4>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Input
            icon="MdBusiness"
            label="Base URL da api"
            name="url"
            type="url"
            required
          />
          <Input
            icon="MdBusiness"
            label="URL de listagem dos corretores"
            name="url_corretores"
            type="text"
          />
          <Input
            icon="MdBusiness"
            label="URL de listagem dos produtos"
            name="url_produtos"
            type="text"
          />
          <Input
            icon="MdBusiness"
            label="Parâmetro post"
            name="post"
            type="text"
            required
          />
          <Input
            icon="MdBusiness"
            label="Parâmetro"
            name="parametro"
            type="text"
            required
          />
          <Input
            icon="MdBusiness"
            label="Nome"
            name="name"
            type="text"
            required
          />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}
